import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { AccessibilityProvider } from "./context/AccessibilityContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminLayout from "./components/AdminLayout";

import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import AuthCallback from "./pages/AuthCallback";
import Profile from "./pages/Profile";
import ContestsList from "./pages/ContestsList";
import ContestDetail from "./pages/ContestDetail";
import ExamRoom from "./pages/ExamRoom";
import Result from "./pages/Result";
import Leaderboard from "./pages/Leaderboard";
import VotePage from "./pages/VotePage";
import Analytics from "./pages/Analytics";
import JuryPortal from "./pages/JuryPortal";
import AdminDashboard from "./pages/AdminDashboard";
import AdminContestForm from "./pages/AdminContestForm";
import AdminQuestionsManager from "./pages/AdminQuestionsManager";
import AdminAISettings from "./pages/AdminAISettings";
import AdminDocuments from "./pages/AdminDocuments";
import PublicDocuments from "./pages/PublicDocuments";

function AppRouter() {
    const location = useLocation();
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    if (location.hash?.includes("session_id=")) return <AuthCallback />;

    const isAdminRoute = location.pathname.startsWith("/quan-tri");

    return (
        <>
            <Navbar />
            <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/dang-nhap" element={<Login />} />
                <Route path="/dang-ky" element={<Register />} />

                <Route path="/cuoc-thi" element={<ContestsList />} />
                <Route path="/cuoc-thi/:id" element={<ContestDetail />} />
                <Route path="/cuoc-thi/:id/lam-bai" element={<ProtectedRoute><ExamRoom /></ProtectedRoute>} />
                <Route path="/ket-qua/:submissionId" element={<ProtectedRoute><Result /></ProtectedRoute>} />

                <Route path="/bang-xep-hang" element={<Leaderboard />} />
                <Route path="/bang-xep-hang/:contestId" element={<Leaderboard />} />
                <Route path="/binh-chon" element={<VotePage />} />
                <Route path="/thu-vien" element={<PublicDocuments />} />

                <Route path="/thong-ke" element={<Analytics />} />
                <Route path="/ho-so" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
                <Route path="/giam-khao" element={
                    <ProtectedRoute roles={["jury", "btc_admin", "super_admin"]}><JuryPortal /></ProtectedRoute>
                } />

                {/* Admin routes wrapped in AdminLayout (sidebar) */}
                <Route element={<ProtectedRoute roles={["btc_admin", "super_admin"]}><AdminLayout /></ProtectedRoute>}>
                    <Route path="/quan-tri" element={<AdminDashboard />} />
                    <Route path="/quan-tri/cuoc-thi/moi" element={<AdminContestForm />} />
                    <Route path="/quan-tri/cuoc-thi/:id" element={<AdminContestForm />} />
                    <Route path="/quan-tri/cuoc-thi/:contestId/cau-hoi" element={<AdminQuestionsManager />} />
                    <Route path="/quan-tri/thu-vien" element={<AdminDocuments />} />
                    <Route path="/quan-tri/cai-dat-ai" element={<AdminAISettings />} />
                </Route>

                <Route path="*" element={
                    <div className="pt-32 text-center container-x">
                        <h1 className="font-heading text-4xl">404</h1>
                        <p className="text-slate-500 mt-2">Trang không tồn tại</p>
                    </div>
                } />
            </Routes>
            {!isAdminRoute && <Footer />}
        </>
    );
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AccessibilityProvider>
                    <AuthProvider>
                        <AppRouter />
                    </AuthProvider>
                </AccessibilityProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
